<template>
  <div>
    <div class="dashboard-card light upcoming-appt no-appt" v-if="display === 'explainer'">
      <div class="row row-eq-height">
        <div class="col-12 col-md-4 text-center d-md-none d-lg-none d-xl-block">
          <img
            class="upcoming__img img-fluid"
            src="@/assets/img/computer@2x.png"
            alt="BetterMynd"
          >
        </div>
        <div class="col-12 col-xl-8">
          <div class="vertical-align-md">
            <div class="holder">
              <label>SESSION REMINDERS</label>
              <p style="font-size: 17px;">
                When you have a session booked, the link for your counseling session will
                appear here <b>15 minutes before the start of the session</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-card light upcoming-appt" v-if="display === 'session'">
      <div class="row row-eq-height">
        <div class="col-12 col-md-4 text-center d-md-none d-lg-none d-xl-block">
          <img
            class="upcoming__img img-fluid"
            src="@/assets/img/computer@2x.png"
            alt="BetterMynd"
          >
        </div>
        <div class="col-12 col-xl-8">
          <div class="vertical-align-md">
            <div class="holder">
              <label>SESSION REMINDER</label>
              <h2>{{ activeSession.start | format('MMMM Do h:mm A') }}</h2>
              <p>with <router-link :to="`/student/counselor/profile/${activeSession.counselor.id}`">{{ activeSession.counselor.name }}</router-link></p>
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
            <a :href="displayed_join.join_url"
            target="_blank"
            class="icon-btn">
              <button class="btn btn-primary btn-block w-100" type="button">
                Join Session 
                <font-awesome-icon
                  :icon="['fas', 'video']"
                  class="icon alt pulse"
                  />
                </button>
            </a>
          </div>
      </div>
    </div>
    <div class="dashboard-card light upcoming-appt" v-if="display === 'workshop'">
      <div class="row row-eq-height">
        <div class="col-12 col-md-4 text-center d-md-none d-lg-none d-xl-block">
          <img
            class="upcoming__img img-fluid"
            src="@/assets/img/computer@2x.png"
            alt="BetterMynd"
          >
        </div>
        <div class="col-12 col-xl-8">
          <div class="vertical-align-md">
            <div class="holder">
              <label>WORKSHOP REMINDER</label>
              <h2>{{ activeWorkshop.start_time | format('MMMM Do h:mm A') }}</h2>
              <p>{{activeWorkshop.topic}}</p>
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
            <a :href="displayed_join.join_url"
            target="_blank"
            class="icon-btn">
              <button class="btn btn-primary btn-block w-100" type="button">
                Join Workshop 
                <font-awesome-icon
                  :icon="['fas', 'video']"
                  class="icon alt pulse"
                  />
                </button>
            </a>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import MeetingsClient from '@/api/MeetingsClient';
import WorkshopClient from '@/api/WorkshopClient';
export default {
  props: {
    workshops: [],
    sessions: [],
  },
  data() {
    return {
      meetingsClient: new MeetingsClient(this.$http),
      workshopsClient: new WorkshopClient(this.$http),

      activeSession: null,
      activeWorkshop: null,

      displayed_join: {
        session: null,
        workshop: null,
        url: null,
      },
    }
  },
  async mounted() {
    await this.tryFetchJoinUrlAndRePoll();
  },
  computed:{
    display() {
      if(this.activeSession) 
        return 'session';
      if(this.activeWorkshop)
        return 'workshop';
      return 'explainer';
    },
  },
  methods: {
    toMoment(datetime){
      return moment(datetime);
    },
    async tryFetchJoinUrlAndRePoll() {
      this.activeSession = this.getActiveSession();
      this.activeWorkshop = this.getActiveWorkshop();

      if(this.activeSession && (!this.displayed_join.join_url || this.activeSession != this.displayed_join.session))
        try {
          const response = await this.meetingsClient.join(this.activeSession.meeting_id);
          this.displayed_join = {
            session: this.activeSession,
            workshop: null,
            join_url: response,
          }
        } catch(ex) {
          console.error(ex);
          this.displayed_join = {
            session: null,
            workshop: null,
            join_url: null,
          }
        }

      if(this.activeWorkshop && (!this.displayed_join.join_url || this.activeWorkshop && this.activeWorkshop != this.displayed_join.workshop))
        try {
          const response = await this.meetingsClient.join(this.activeWorkshop.meeting_id);
          this.displayed_join = {
            session: null,
            workshop: this.activeWorkshop,
            join_url: response,
          }
        } catch(ex) {
          console.error(ex);
          this.displayed_join = {
            session: null,
            workshop: null,
            join_url: null,
          }
        }
      
      const wait = 1000 * 15;
      setTimeout(this.tryFetchJoinUrlAndRePoll.bind(this), wait);
    },
    getActiveSession() {
      for(const session of this.sessions) {
        const start = moment(session.start_time);
        const end = moment(session.end_time);
        const now = moment();
        if(start.diff(now, 'minutes') < 15 && end > now)
          return session;
      }
      return null;
    },
    getActiveWorkshop() {
      for(const workshop of this.workshops) {
        const start = moment(workshop.start_time);
        const end = moment(workshop.end_time);
        const now = moment();
        if(start.diff(now, 'minutes') < 15 && end > now)
          return workshop;
      }
      return null;
    },
  },
}
</script>

<style>

</style>